import { render } from "./ReceiptDetail.vue?vue&type=template&id=40f6c736&scoped=true"
import script from "./ReceiptDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptDetail.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=40f6c736&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f6c736"]])

export default __exports__